import LimeAPI from "../classes/LimeAPI";
import store from "../store";

/**
 * Ensures Redux currentProject matches the project segment of the URL.
 * Required for deep links where the user never visited /projects/:id first.
 */
export function projectMatchesRoute(projectIdParam: string): boolean {
  const projectId = parseInt(projectIdParam, 10);
  if (Number.isNaN(projectId)) {
    return false;
  }
  return store.getState().currentProject.id === projectId;
}

/**
 * Ensures Redux currentQualityDocument matches the document segment of the URL.
 */
export function qualityDocumentMatchesRoute(documentIdParam: string): boolean {
  const docId = parseInt(documentIdParam, 10);
  if (Number.isNaN(docId)) {
    return false;
  }
  return store.getState().currentQualityDocument._id === docId;
}

export async function fetchProjectIfNeeded(
  projectIdParam: string,
  signal: AbortSignal,
  setCurrentProject: (project: object) => void,
): Promise<void> {
  if (projectMatchesRoute(projectIdParam)) {
    return;
  }
  const project = await LimeAPI.get(`projects/${projectIdParam}`, signal);
  setCurrentProject(project);
}

export async function fetchQualityDocumentIfNeeded(
  documentIdParam: string,
  signal: AbortSignal,
  setQualityDocument: (document: object) => void,
): Promise<void> {
  if (qualityDocumentMatchesRoute(documentIdParam)) {
    return;
  }
  const document = await LimeAPI.get(
    `qualitydocuments/${documentIdParam}`,
    signal,
  );
  setQualityDocument(document);
}
